export default function Detail({ label, value }) {
  return (
    <div className="flex flex-wrap items-start justify-between md:text-2xl font-indi mb-2">
      <span>{label}</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}
